import React from "react";

// A small hand-drawn style oil lamp (diya) with a flickering flame.
const Diya = ({ size = 56, delay = 0 }) => {
  return (
    <div
      className="relative flex flex-col items-center"
      style={{ animation: `gentle-float 4s ease-in-out ${delay}s infinite` }}
      data-testid="diya"
    >
      {/* Flame */}
      <div className="flame relative -mb-1 z-10" style={{ width: size * 0.28, height: size * 0.5 }}>
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse at 50% 80%, #fff3c4 0%, #FF9933 40%, #8C1C31 90%, transparent 100%)",
            borderRadius: "50% 50% 50% 50% / 60% 60% 40% 40%",
            filter: "drop-shadow(0 0 12px rgba(255,153,51,0.8))",
          }}
        />
        <div
          className="absolute left-1/2 top-[35%] -translate-x-1/2"
          style={{
            width: "40%",
            height: "45%",
            background: "radial-gradient(ellipse at 50% 70%, #fffbe6 0%, #ffd27a 70%, transparent 100%)",
            borderRadius: "50% 50% 50% 50% / 60% 60% 40% 40%",
          }}
        />
      </div>

      {/* Lamp body */}
      <svg width={size} height={size * 0.42} viewBox="0 0 100 42" fill="none">
        <defs>
          <linearGradient id={`lamp-${delay}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#E8C874" />
            <stop offset="45%" stopColor="#C9992E" />
            <stop offset="100%" stopColor="#7a5a12" />
          </linearGradient>
        </defs>
        <path
          d="M4 6 Q50 -4 96 6 Q92 34 50 40 Q8 34 4 6 Z"
          fill={`url(#lamp-${delay})`}
          stroke="#D4AF37"
          strokeWidth="1.5"
        />
        <ellipse cx="50" cy="8" rx="44" ry="6" fill="#3a2408" opacity="0.6" />
      </svg>
    </div>
  );
};

export default Diya;
